export const API = process.env.REACT_APP_API_URL;
export const FIREBASE_AUTH_ANONSIGNIN =
  process.env.REACT_APP_Firebase_AnonSignIN;
export const JAVA_SVC = process.env.REACT_APP_BE_SVC_URL;
export const JAVA_PVSVC = process.env.REACT_APP_BE_PVSVC_URL;
export const MURADI_BACKOFFICE = process.env.REACT_APP_BO_URL;
export const GOOGLE_AUTH_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
export const FACEBOOK_AUTH_ID = process.env.REACT_APP_FACEBOOK_APP_ID;
